const musicalArtsEducationColors = {
  MUSIC_50: '#E0F7F9',
  MUSIC_100: '#B2ECF1',
  MUSIC_200: '#80DFE8',
  MUSIC_800: '#00858E',
}

export default musicalArtsEducationColors
